import { lazy } from "react";
import { ROUTES } from "../constants/routes";

const HowToUsePage = lazy(() => import("../pages/HowToUsePage"));
const LandingPage = lazy(() => import("../pages/LandingPage"));
const TermsPage = lazy(() => import("../pages/TermsPage"));
const TermsDetailPage = lazy(() => import("../pages/TermsDetailPage"));
const MainPage = lazy(() => import("../pages/MainPage"));
const AccountPage = lazy(() => import("../pages/AccountPage"));
const MyOffersPage = lazy(() => import("../pages/MyOffersPage"));
const SearchCargoPage = lazy(() => import("../pages/SearchCargoPage"));
const SearchTransportPage = lazy(() => import("../pages/SearchTransportPage"));
const MyRequestsPage = lazy(() => import("../pages/MyRequestsPage"));
const MyBidPage = lazy(() => import("../pages/MyBidPage"));
const ChatPage = lazy(() => import("../pages/ChatPage"));
const DeliveryPage = lazy(() => import("../pages/DeliveryPage"));

const NewsDetailPage = lazy(
	() => import("../pages/NewsDetailPage/NewsDetailPage"),
);
const NewsListPage = lazy(() => import("../pages/NewsListPage/NewsListPage"));

export type RouteType = "public" | "private";

export interface AppRoute {
	path: string;
	// eslint-disable-next-line
	component: React.LazyExoticComponent<React.ComponentType<any>>;
	type: RouteType;
	layoutType?: "landing" | "platform";
}

export const routesConfig: AppRoute[] = [
	{
		path: ROUTES.HOME,
		component: LandingPage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.NEWS, // e.g. "/news"
		component: NewsListPage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.NEWS_DETAIL, // e.g. "/news/:slug"
		component: NewsDetailPage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.HOW_TO_USE,
		component: HowToUsePage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.TERMS,
		component: TermsPage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.TERMS_DETAIL,
		component: TermsDetailPage,
		type: "public",
		layoutType: "landing",
	},
	{
		path: ROUTES.MAIN,
		component: MainPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.ACCOUNT,
		component: AccountPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.MY_OFFERS,
		component: MyOffersPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.CARGO_SEARCH,
		component: SearchCargoPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.TRANSPORT_SEARCH,
		component: SearchTransportPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.MY_REQUESTS,
		component: MyRequestsPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.MY_BIDS,
		component: MyBidPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.CHAT,
		component: ChatPage,
		type: "private",
		layoutType: "platform",
	},
	{
		path: ROUTES.DELIVERIES,
		component: DeliveryPage,
		type: "private",
		layoutType: "platform",
	},
];
